export default "__VITE_ASSET__BG16PnlA__"